import React from 'react';
import { Popover, Col } from 'antd';
import Translated from 'components/Translated';
import Locale from 'components/Locale';
import { getAccess } from 'utils';
import Searchs from './Searchs';
import FavoritesOrder from './FavoritesOrder';
import FavoritesQuotes from './FavoritesQuotes';
import { StyleMenu, StyledRow, StyledLocale, StyledButton, StyledHeader, StyledSide, StyledRowSide, StyledLogo, StyledSearchs, StyledFavorites } from './Topbar.styled';


const Topbar = ({ admin, locale, menuCollapsed, userPermissions, toggleMobileMenu, toggleCollapsingMenu }) => {
    // useEffect(() => {
    //     loadFavorisOrder();
    // }, []);

    function handleMobile() {
        toggleMobileMenu();

        if (menuCollapsed) {
            toggleCollapsingMenu();
        }
    }

    const userRoles = {
        orders: getAccess(userPermissions, 'orders'),
        quotes: getAccess(userPermissions, 'quotes'),
    };

    return (
        <StyledHeader>
            <StyledRow type="flex" gutter={16} className="gx-align-items-center">
                <Col className="gx-d-block gx-d-lg-none gx-pointer" xs={10} sm={8} md={6}>
                    <StyleMenu shape="circle" onClick={handleMobile}>
                        <i className="la la-navicon" />
                    </StyleMenu>

                    <StyledLogo to="/dashboard" className="gx-w-logo">
                        <img alt="" src={`${process.env.REACT_APP_CDN}admin/logos/${admin}.png`} />
                    </StyledLogo>
                </Col>

                <StyledSearchs md={10} lg={14} className="gx-d-md-block">
                    <Searchs />
                </StyledSearchs>

                <StyledSide xs={14} md={8}>
                    <StyledRowSide gutter={16} className="gx-align-items-center gx-justify-content-end gx-w-100">
                        {
                            userRoles.quotes.includes('read') && (
                                <Col className="favourites-quotes">
                                    <Popover
                                        title={<Translated id="quote.listFavoris" />}
                                        overlayClassName="gx-popover-horizantal"
                                        placement="bottomRight"
                                        content={<FavoritesQuotes />}
                                        trigger="click"
                                    >
                                        <StyledFavorites className="gx-align-items-center">
                                            <header>
                                                <div className="gx-position-relative gx-d-inline-block">
                                                    <i className="la la-file-invoice favicon gx-fs-xxxl" />
                                                    <i className="la la-star gx-fs-lg" />
                                                </div>
                                                <span className="gx-fs-xs gx-d-block"><Translated id="navigation.quotes" /></span>
                                            </header>
                                            <i className="la la-angle-down gx-pl-2" />
                                        </StyledFavorites>
                                    </Popover>
                                </Col>
                            )
                        }

                        {
                            userRoles.orders.includes('read') && (
                                <Col className="favourites-orders">

                                    <Popover
                                        title={<Translated id="order.listFavoris" />}
                                        overlayClassName="gx-popover-horizantal"
                                        placement="bottomRight"
                                        content={<FavoritesOrder />}
                                        trigger="click"
                                    >
                                        <StyledFavorites className="gx-align-items-center">
                                            <header>
                                                <div className="gx-position-relative gx-d-inline-block">
                                                    <i className="la la-shopping-cart favicon gx-fs-xxxl" />
                                                    <i className="la la-star gx-fs-lg" />
                                                </div>
                                                <span className="gx-fs-xs gx-d-block"><Translated id="navigation.orders" /></span>
                                            </header>
                                            <i className="la la-angle-down gx-pl-2" />
                                        </StyledFavorites>
                                    </Popover>
                                </Col>
                            )
                        }

                        <Col className="locales">
                            <aside className="gx-language">
                                <Popover
                                    overlayClassName="gx-popover-horizantal"
                                    placement="bottomRight"
                                    content={<Locale />}
                                    trigger="click"
                                >
                                    <StyledLocale className="gx-pointer gx-flex-row gx-align-items-center">
                                        <i className="la la-language la-lg" />
                                        <span className="gx-language"><Translated id={`locale.${locale}`} /></span>
                                        <i className="la la-angle-down gx-pl-2" />
                                    </StyledLocale>
                                </Popover>
                            </aside>
                        </Col>

                        <Col className="icon-search">
                            <Popover
                                placement="bottomRight"
                                content={<Searchs />}
                                trigger="click"
                            >
                                <StyledButton shape="circle" className="gx-pointer"><i className="la la-search" /></StyledButton>
                            </Popover>
                        </Col>
                    </StyledRowSide>
                </StyledSide>
            </StyledRow>
        </StyledHeader>
    );
};

export default Topbar;
